module.exports = __webpack_public_path__ + "img/yingtao_message_bac.dba6bb79.png";